module.exports = __webpack_public_path__ + "img/5.c98945b0.png";